import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CreateBackupModal = ({ show, onHide, onCreate }) => {
    const [backupName, setBackupName] = useState('');

    const handleCreate = () => {
        onCreate(backupName);
        setBackupName('');
        onHide();
    };

    const handleClose = () => {
        setBackupName('');
        onHide();
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            slotProps={{
                paper: {
                    style: {
                        borderRadius: '12px',
                        padding: '0.5rem'
                    }
                }
            }}
        >
            <DialogTitle style={{
                fontFamily: 'var(--font-family-base)',
                fontWeight: '600',
                fontSize: '1.5rem',
                color: '#1e293b',
                paddingRight: '3rem'
            }}>
                <i className="bi bi-plus-circle-fill text-primary me-2"></i>
                Crear Backup Manual
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{ padding: '1.5rem' }}>
                <TextField
                    autoFocus
                    margin="dense"
                    id="backupName"
                    label="Nombre del Backup (opcional)"
                    type="text"
                    fullWidth
                    variant="outlined"
                    placeholder="Ej: backup_clientes_importantes"
                    value={backupName}
                    onChange={(e) => setBackupName(e.target.value)}
                    InputProps={{
                        style: {
                            fontFamily: 'var(--font-family-base)',
                            borderRadius: '8px'
                        }
                    }}
                    InputLabelProps={{
                        style: {
                            fontFamily: 'var(--font-family-base)'
                        }
                    }}
                    helperText="Si no ingresa un nombre, se generará uno automáticamente con la fecha y hora"
                    FormHelperTextProps={{
                        style: {
                            fontFamily: 'var(--font-family-base)',
                            color: '#64748b'
                        }
                    }}
                />
            </DialogContent>
            <DialogActions style={{ padding: '1rem 1.5rem' }}>
                <Button
                    onClick={handleClose}
                    style={{
                        fontFamily: 'var(--font-family-base)',
                        fontWeight: '600',
                        color: '#64748b',
                        borderRadius: '8px'
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleCreate}
                    variant="contained"
                    style={{
                        fontFamily: 'var(--font-family-base)',
                        fontWeight: '600',
                        background: '#3B82F6',
                        borderRadius: '8px',
                        padding: '0.5rem 1.5rem'
                    }}
                >
                    <i className="bi bi-check-lg me-2"></i>
                    Crear Backup
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateBackupModal;

